import gql from 'graphql-tag';

const CREATE_TEAM = gql`
  mutation createTeam($data: TeamCreateInput!) {
    createTeam(data: $data) {
      id
      name
      description
      org {
        id
        name
      }
      members {
        id
        name
        username
        avatar {
          id
          key
        }
      }
      subscribers {
        id
        name
        username
      }
      subscribedTeams {
        id
        name
      }
      leader {
        id
        name
        username
      }
      createdBy {
        id
        name
      }
      createdAt
    }
  }
`;

export default CREATE_TEAM;
